import VideoPlayer from "./VideoPlayer"
import DisclaimerWarning from "../DisclaimerWarning"
import { useRef, useState, useEffect } from "react"
import { Trans, useTranslation } from "next-i18next"
import clsx from "clsx"
import HALO from "vanta/dist/vanta.halo.min"
import * as THREE from "three"
import { isTouchDevice } from "../../utils/browser"

import HomeMainButtons from "./HomeMainButtons"

import Styles from "./Hero.module.scss"

export default function Hero({ announcement }) {
  const { t } = useTranslation("common")

  const hasAnnouncement = announcement && announcement.title

  const [vantaEffect, setVantaEffect] = useState(null)
  const myRef = useRef(null)

  useEffect(() => {
    if (!vantaEffect && !isTouchDevice()) {
      setVantaEffect(
        HALO({
          el: myRef.current,
          mouseControls: true,
          touchControls: true,
          gyroControls: true,
          minHeight: 200.0,
          minWidth: 200.0,
          yOffset: 0.1,
          // yOffset: 0.05,
          baseColor: 0xbb004b,
          backgroundColor: 0x17abfc,
          baseColor: "#b6fede",
          speed: 1.3,
          size: 0.35,
          THREE: THREE, // use a custom THREE when initializing
        })
      )
    }
    return () => {
      if (vantaEffect) vantaEffect.destroy()
    }
  }, [vantaEffect])

  return (
    <div ref={myRef} id="vox-hero">
      <div className={Styles.Announcement}>
        <div className={Styles.AnnouncementText}>
          <Trans i18nKey="HOME_ANNOUNCEMENT" />
        </div>
      </div>

      <div
        className={clsx(
          Styles.Hero,
          hasAnnouncement && Styles.HeroWithAnnouncement
        )}
        id="page-wrap"
      >
        <div className={Styles.HeroMainTextWrapper}>
          <h1 className={Styles.HeroMainText}>
            <Trans i18nKey="VOXME_WELCOME_MESSAGE" />
          </h1>
          <div className={Styles.HeroMainSubText}>
            <Trans i18nKey="VOXME_WELCOME_MESSAGE_SUBTITLE" />
          </div>
        </div>
      </div>

      <div className={Styles.HeroMainCTA}>
        <h2 className="hidden text-center lg:block mt-10 text-2xl">
          {t("HOME_INSTRUCTIONS")}
        </h2>

        <HomeMainButtons />
      </div>

      <div className={clsx(Styles.DisclaimerWrapper)}>
        <DisclaimerWarning />
      </div>
    </div>
  )
}
